import type { IconName } from '@/components/entities/Sprite/Icon';
import type { CategoryListItemDto } from '@/queries/categories/categories.schema';
import { Icon } from '@/components/entities/Sprite/Icon';
import { CATEGORY_ICONS } from '@/consts/CategoryIcons';
import { useSidebarLink } from '@/hooks/useLinkHandler';
import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { capitalizeWords } from '@/utils/texts.utils';

const CategoryItem = ({ category, categoryId, handleCloseSideBar, isMenuMinify, className }: {
  category: CategoryListItemDto;
  categoryId: string;
  handleCloseSideBar?: () => void;
  isMenuMinify: boolean;
  className?: string;
}) => {
  const categoryUrl = AppRoutes.categoryIdPaged(category.id);

  const handleClick = useSidebarLink(handleCloseSideBar);
  return (
    <Link
      key={category.id}
      href={categoryUrl}
      onClick={e => handleClick(e, categoryUrl)}
      className={cn('transition-all duration-150 ease-in-out w-full cursor-pointer hover:scale-[1.02]', className)}
      prefetch={false}
    >
      <div className={cn(
        'relative flex items-center gap-2 py-2.5 3xl:py-3.5 pl-3 lg:px-3 rounded-[3.125rem]',
        'text-violet-c100 paragraph-s-medium 3xl:paragraph-m-regular font-normal',
        'hover:text-violet-c100',
        'before:content-[""] before:absolute before:inset-0 before:rounded-[3.125rem]',
        'before:bg-header-gradient',
        'before:opacity-0 before:transition-opacity before:duration-200',
        'before:-z-10 hover:before:opacity-100',
        categoryId === category.id && 'before:opacity-100 text-white',
      )}
      >
        <Icon
          name={CATEGORY_ICONS[category.id] as IconName}
          className={cn('relative size-6 shrink-0', categoryId === category.id && 'text-white')}
        />
        <span
          className={cn(
            'relative overflow-hidden whitespace-nowrap',
            isMenuMinify ? 'opacity-0 max-w-0 ml-[-10px]' : 'opacity-100 max-w-[200px]',
            categoryId === category.id && 'text-white',
          )}
        >
          {capitalizeWords(category.name)}
        </span>
      </div>
    </Link>
  );
};

export default CategoryItem;
